/* src/app/shared/order-form/order-form/order-form-header/order-form-header.component.scss */
.header {
  margin-top: 20px;
}
::ng-deep .icon-delete.cw-delete {
  margin-left: 16px;
}
form .cw-flex-row .cw-toolbar-icon {
  background-color: transparent;
  border: 1px solid transparent;
  color: var(--color-primary-dark);
  font-size: 15px;
  height: 25px;
  margin-left: 2px;
  width: 25px;
}
form .cw-flex-row .cw-toolbar-icon:hover {
  border-color: var(--color-primary-dark);
}
form .cw-flex-row .cw-toolbar-icon:active {
  background-color: var(--color-primary-dark);
  color: var(--color-default-light);
}
/*# sourceMappingURL=order-form-header.component.css.map */
